// Dev-only shared flag: when on, the real saveQuote() network call is
// swapped for a synthetic 403 rejection, so the actual save code path
// (server-api.js catch, popups, recovery flow) can be exercised end-to-end
// instead of just testing the generic error-reporting pipeline in isolation.
let forceSaveQuoteFailureEnabled = false;

export const isForceSaveQuoteFailureEnabled = () => forceSaveQuoteFailureEnabled;

export const setForceSaveQuoteFailureEnabled = (value) => {
  forceSaveQuoteFailureEnabled = value;
};

export const createForcedSaveQuoteFailure = () => {
  const error = new Error('Request failed with status code 403');
  error.name = 'AxiosError';
  error.response = {status: 403};
  return error;
};
